 const BASE_URL="https://krumago-application-assets.s3.us-east-1.amazonaws.com/Institution+Domain+Assets/";

export const SERVICE_DOMAIN = {
 
    LANDING_PAGE: {
        IMAGE_1: `${BASE_URL}images/aariimage.png`,
        IMAGE_2: `${BASE_URL}images/customer.jpg`,
        IMAGE_3: `${BASE_URL}images/Krumagoimg.png`,
    },
};